export function normalizeRuPhoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '')

  if (!digits) return ''

  if (digits[0] === '8') {
    digits = `7${digits.slice(1)}`
  }

  if (digits[0] !== '7') {
    digits = `7${digits}`
  }

  return digits.slice(0, 11)
}

export function formatRuPhone(value) {
  const digits = normalizeRuPhoneDigits(value)

  if (!digits) return ''

  const operator = digits.slice(1, 4)
  const part1 = digits.slice(4, 7)
  const part2 = digits.slice(7, 9)
  const part3 = digits.slice(9, 11)

  let phone = '+7'

  if (operator) phone += ` ${operator}`
  if (part1) phone += ` ${part1}`
  if (part2) phone += ` ${part2}`
  if (part3) phone += ` ${part3}`

  return phone
}

export function isValidRuPhone(value) {
  const digits = normalizeRuPhoneDigits(value)
  return digits.length === 11 && digits[0] === '7'
}